export default function genererCritereRechercheCatalogueProduit() {
  return {
    categorie: [],
    actif: true,
    societeId: null,
    mairieEtNonCommercialisable: false,
    sansProduitMateriel: true,
    agencesId: [],
    avecLiaisons: null,
    stockable: null,
    produitRenouvelable: null,
  };
}
